/**
 * Paperclip glyph used across attachment/document affordances (activity
 * attachments, bank-statement line documents, supplier invoice documents,
 * dashboard chat composer, email attachment indicator).
 *
 * Decorative by default (`aria-hidden`). Pass `title` when the icon is the
 * only signal of an informative state with no adjacent label - it then
 * renders the informative-icon a11y pattern (`role="img"` + `aria-label` +
 * `<title>`) so it is announced to screen readers.
 */
export function PaperclipIcon({ className, title }: { className?: string; title?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      {title && <title>{title}</title>}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
      />
    </svg>
  );
}
